export const preloadedValues = {
  cnFmRecStatus: false,
  cnFmCnPgId: "",
};
